import request from '@/utils/request'


export const belgelerGetir = (tur, ne, aranan,currentPage, pageSize, sortBy, sortDesc, durum,id) => {
    return request({
        url: tur === 'kart' ? '/Kart/belgeler' : '/Mektup/belgeler',
        params: {
            ne,
            aranan,
            currentPage,
            pageSize,
            sortBy,
            sortDesc,
            durum,
            id
        }
    })
};

export const KisiBazliHaftalikRapor = (tur, baslangicTarih, bitisTarih) => {
    return request({
        url: tur === 'kart' ? '/Kart/KisiBazliHaftalikRapor' : '/Mektup/KisiBazliHaftalikRapor',
        params: {
            baslangicTarih,
            bitisTarih
        }
    })
}

export const ToplamHaftalikRapor = () => {
    return request({
        url: '/Mektup/HaftalikToplamRapor' //Ture ne yazdığın fark etmez.
    })
}

export const HaftalikHedefIstatistikRapor = () => {
    return request({
        url: '/Mektup/HaftalikHedefIstatistikRapor' //Ture ne yazdığın fark etmez.
    })
}

export const HaftalikSaatselRapor = (tur, baslangicTarih) => {
    return request({
        url: tur === 'kart' ? '/Kart/HaftalikSaatselRapor' : '/Mektup/HaftalikSaatselRapor',
        params: {
            baslangicTarih
        }
    })
}

export const VazifesiniYapmayanKisiSayisi = () => {
    return request({
        url: '/Kart/VazifesiniYapmayanKisiSayisi',
    })
}